import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Col } from 'reactstrap';
import BaseLoader from './parts/BaseLoader';
import { isNumber } from '../../../../../../../utils/math';
import ProgressByCurrentPeriod from './parts/ProgressByCurrentPeriod';
import { TranslationsKeys } from '../../../../../../../locales/translations';

interface ProgressInCurrentPeriodProps {
  studyPlanEnrollmentId: string | undefined;
}

export default function ProgressInCurrentPeriod({
  studyPlanEnrollmentId,
}: ProgressInCurrentPeriodProps) {
  const { t } = useTranslation(TranslationsKeys.STUDENT_FILE_ACADEMIC_HISTORY);

  const texts = useMemo(
    () => ({
      progress: {
        table: {
          columns: {
            section: t(`curriculumProgressStudent.progress.section`),
            courseCode: t(`curriculumProgressStudent.progress.courseCode`),
            generalPassedAverage: t(
              `curriculumProgressStudent.progress.generalPassedAverage`,
            ),
            averageGradeToDate: t(
              `curriculumProgressStudent.progress.averageGradeToDate`,
            ),
            progressPorcentInGrades: t(
              `curriculumProgressStudent.progress.progressPorcentInGrades`,
            ),
            averageAttendanceToDate: t(
              `curriculumProgressStudent.progress.averageAttendanceToDate`,
            ),
            attendanceCatedral: t(
              `curriculumProgressStudent.progress.attendanceCatedral`,
            ),
            attendanceLaboratory: t(
              `curriculumProgressStudent.progress.attendanceLaboratory`,
            ),
            attendanceAssistantship: t(
              `curriculumProgressStudent.progress.attendanceAssistantship`,
            ),
          },
          tooltips: {
            attendanceCatedral: t(
              `curriculumProgressStudent.progress.tooltip.attendanceCatedral`,
            ),
            attendanceLaboratory: t(
              `curriculumProgressStudent.progress.tooltip.attendanceLaboratory`,
            ),
            attendanceAssistantship: t(
              `curriculumProgressStudent.progress.tooltip.attendanceAssistantship`,
            ),
          },
          notActivePeriod: {
            title: t(
              `curriculumProgressStudent.progress.notActivePeriod.title`,
            ),
            subtitle: t(
              `curriculumProgressStudent.progress.notActivePeriod.subtitle`,
            ),
          },
          notResult: {
            title: t(`curriculumProgressStudent.progress.notResult.title`),
            subtitle: t(
              `curriculumProgressStudent.progress.notResult.subtitle`,
            ),
          },
        },
      },
    }),
    [t],
  );

  const studyPlanEnrollmentIdValid = useMemo(() => {
    if (isNumber(studyPlanEnrollmentId)) {
      return Number(studyPlanEnrollmentId);
    }
    return null;
  }, [studyPlanEnrollmentId]);

  if (!studyPlanEnrollmentIdValid) {
    return <h2 className="text-center">{t('noStudyPlanEnrollmentId')}</h2>;
  }

  return (
    <BaseLoader studyPlanEnrollmentId={studyPlanEnrollmentIdValid}>
      {(data) => (
        <Col className="mt-4 px-0">
          <ProgressByCurrentPeriod
            progressCurrentPeriod={data.progressCurrentPeriod}
            periodActive={data.periodActive}
            texts={texts.progress}
          />
        </Col>
      )}
    </BaseLoader>
  );
}
